import {
  FETCH_MONTHLY_FUNDING_COUNTS_START,
  FETCH_MONTHLY_FUNDING_COUNTS_SUCCESS,
  FETCH_MONTHLY_FUNDING_COUNTS_FAIL,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  data: [],
  isFetching: true,
  errorMessage: '',
}

const monthlyFundingCountsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MONTHLY_FUNDING_COUNTS_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      }
    case FETCH_MONTHLY_FUNDING_COUNTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
        errorMessage: '',
      }
    case FETCH_MONTHLY_FUNDING_COUNTS_FAIL:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default monthlyFundingCountsReducer
